namespace GeniuzPOS.Lookups {
    export namespace VwUsernameService {
        export const baseUrl = 'Lookups/VwUsername';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwUsernameRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwUsernameRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwUsername/Retrieve",
            List = "Lookups/VwUsername/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwUsernameService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
